import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    dragHandle: props => ({
        '&:hover': {
            cursor: 'pointer',
        },
        color: props.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
        left: theme.spacing(2),
        position: 'absolute',
        top: theme.spacing(3),
    }),
    root: {
        display: 'flex',
        justify: 'center',
        padding: theme.spacing(1), // background:theme.palette.secondary.main
        position: 'relative',
        width: '100%',
    },
    sortableCollection: props => ({
        '& li': {
            flex: 1,
            flexBasis: 'auto',
            maxWidth: props.type === 'card' ? '25%' : '100%',
        },
        display: props.type === 'card' ? 'flex' : 'block',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        listStyle: 'none',
        // maxHeight: props.maxHeight ? props.maxHeight : 'none',
        overflow: 'scroll',
        padding: 0,
        width: '100%',
    }),
    sortableCollectionWrapper: {
        listStyle: 'none',
    },
    sortableMember: {
        listStyle: 'none!important',
        padding: theme.spacing(1),
        position: 'relative',
    },
}));
